var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'absolute',
    'flex',
    'items-center',
    'justify-center',
    'p-0.875',
    'rounded-full',
    'top-0',
    'left-0',
    'bottom-0',
    'right-0' ]},[_c('OzBaseButton',{class:[
      // Shape
      'h-8',
      'w-8',
      'rounded-full',

      // Centralize button content
      'flex',
      'items-center',
      'justify-center',

      // Colors
      _vm.buttonColorClass,
      _vm.buttonHoverColorClass,
      _vm.buttonIconColorClass ],on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('OzIcon',{attrs:{"name":_vm.iconName,"size":16}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }